module.exports = __webpack_public_path__ + "static/media/ICX.6e229441.svg";